import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { SelectOption } from '@/components/form-builder/form-builder.types';

@Component({
  selector: 'sm-field-detail-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputTextModule, SelectModule, ButtonModule, TranslateModule],
  template: `
    <div class="space-y-4">
      <div class="flex justify-between items-center">
        <h5 class="text-md font-medium">
          {{ isTableType ? ('dynamicDocument.form.colsTable' | translate) : ('dynamicDocument.form.colList' | translate) }}
        </h5>
        <p-button
          [label]="'dynamicDocument.form.addColumn' | translate"
          (onClick)="onAddDetail()"
          icon="pi pi-plus"
          styleClass="p-button-sm p-button-outlined"></p-button>
      </div>

      <div class="border border-gray-200 rounded-lg overflow-hidden">
        <div class="grid grid-cols-12 p-3 text-sm font-medium h-[48px] items-center">
          <div class="col-span-4 text-center">{{ 'dynamicDocument.form.name' | translate }}</div>
          <div class="col-span-2 text-center">{{ 'dynamicDocument.form.position' | translate }}</div>
          <div class="col-span-4 text-center">{{ 'dynamicDocument.form.type' | translate }}</div>
          <div class="col-span-2 text-center">{{ 'dynamicDocument.form.actions' | translate }}</div>
        </div>

        <div class="divide-y divide-gray-200">
          <div
            *ngFor="let detail of detailsFormArray.controls; let i = index"
            class="grid grid-cols-12 p-3 items-center gap-4 h-[60px]"
            [formGroup]="$any(detail)">
            <div class="col-span-4 space-y-1">
              <input
                pInputText
                [id]="'detailName' + i"
                type="text"
                formControlName="columnName"
                [class.border-red-300]="detail.get('columnName')?.invalid && detail.get('columnName')?.touched"
                class="w-full h-[42px] border-gray-300 hover:border-gray-400 focus:border-primary-500"
                placeholder="Nom" />
            </div>

            <div class="col-span-2 space-y-1">
              <input
                pInputText
                [id]="'detailPos' + i"
                type="number"
                formControlName="columnPos"
                [class.border-red-300]="detail.get('columnPos')?.invalid && detail.get('columnPos')?.touched"
                class="w-full h-[42px] border-gray-300 hover:border-gray-400 focus:border-primary-500"
                placeholder="Position" />
            </div>

            <div class="col-span-4 space-y-1">
              <p-select
                [id]="'detailType' + i"
                [options]="columnTypeOptions"
                formControlName="type"
                optionLabel="name"
                optionValue="code"
                [appendTo]="'body'"
                [class.border-red-300]="detail.get('type')?.invalid && detail.get('type')?.touched"
                class="w-full [&>.p-dropdown]:min-h-[42px] [&>.p-dropdown]:border-gray-300 [&>.p-dropdown]:hover:border-gray-400"></p-select>
            </div>

            <div class="col-span-2 flex justify-center">
              <p-button icon="pi pi-trash" (onClick)="onRemoveDetail(i)" styleClass="p-button-sm p-button-text p-button-danger"></p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class FieldDetailTableComponent {
  private readonly fb = inject(FormBuilder);

  @Input() detailsFormArray: FormArray = this.fb.array([]);
  @Input() isTableType = false;
  @Input() isListType = false;
  @Input() columnTypeOptions: SelectOption[] = [];

  @Output() addDetail = new EventEmitter<void>();
  @Output() removeDetail = new EventEmitter<number>();

  onAddDetail(): void {
    this.addDetail.emit();
  }

  onRemoveDetail(index: number): void {
    this.removeDetail.emit(index);
  }
}
